export enum FuelType {
    SOLAR = "Solar",
    WIND = "Wind",
    STORAGE = "Storage",
    SOLAR_AND_STORAGE = "Solar + Storage",
    WIND_AND_STORAGE = "Wind + Storage"
}

export enum FuelComponentTypes {
    SOLAR = "Solar",
    WIND = "Wind",
    STORAGE = "Storage",

    // This is not a real fuel type/component, but we use this to keep track of
    // the parent component in a hybrid project
    MFO = "MFO"
}
